<template>
  <div class="filter-card mb-5" :class="{'filter-card--crop': crop}" ref="card" :id="`filter-card-collapse-` + id">
    <div class="filter-card__head">
      <div class="filter-card__logo" v-if="card.logo.length">
        <img :alt="card.name" :src="card.logo" />
      </div>
      <h3 class="filter-card__title">{{card.name}}</h3>
    </div>
    <div class="filter-card__body">
      <span class="filter-card__subtitle" v-for="(location, index) in card.locations.items" :key="index">
        {{location.parent}}<span class="filter-card__city-title"> / {{location.name}}</span>
      </span>
    </div>
    <div class="filter-card__main">

      <div class="filter-card__perex">
        <p>{{card.description}}</p>
      </div>

      <div v-if="card.school_type">
        <h6>{{card.school_type.display_name}}</h6>
        <ul>
          <li v-if="card.school_type.name">
            {{card.school_type.name}}
            <abbr v-if="card.school_type.description" :title="card.school_type.description"><i class="filter-card__info-icon"></i></abbr>
          </li>
        </ul>
      </div>

      <div v-if="card.study_programmes.items.length">
        <h6>{{card.study_programmes.display_name}}</h6>
        <ul>
          <li v-for="(study, index) in card.study_programmes.items" :key="index">
            {{study.name}}
            <abbr v-if="study.description" :title="study.description"><i class="filter-card__info-icon"></i></abbr>
          </li>
        </ul>
      </div>

      <div v-if="card.sports.items.length">
        <h6>{{card.sports.display_name}}</h6>
        <ul>
          <li v-for="(activity, index) in card.sports.items" :key="index">
            {{activity.name}}
            <abbr v-if="activity.description" :title="activity.description"><i class="filter-card__info-icon"></i></abbr>
          </li>
        </ul>
      </div>

      <div v-if="card.special_programmes.items.length">
        <h6>{{card.special_programmes.display_name}}</h6>
        <ul>
          <li v-for="(special, index) in card.special_programmes.items" :key="index">
            {{special.name}}
            <abbr v-if="special.description" :title="special.description"><i class="filter-card__info-icon"></i></abbr>
          </li>
        </ul>
      </div>

      <div v-if="card.institutions.items.length">
        <h6>{{card.institutions.display_name}}</h6>
        <ul v-for="(institution, index) in card.institutions.items" :key="index">
          <li>
            {{institution.name ? institution.name : 'Nic tu není'}}
            <abbr v-if="institution.description" :title="institution.description"><i class="filter-card__info-icon"></i></abbr>
          </li>
        </ul>
      </div>

      <div v-if="card.study_levels.items.length">
        <h6>{{card.study_levels.display_name}}</h6>
        <ul>
          <li v-for="(level, index) in card.study_levels.items" :key="index">
            {{level.name}}
            <abbr v-if="level.description" :title="level.description"><i class="filter-card__info-icon"></i></abbr>
          </li>
        </ul>
      </div>

      <a :href="card.map" class="btn btn-outline-primary filter-card__btn" v-if="card.map.length" @click.prevent="showImageModal">Expo map</a>

      <div class="filter-card__action">
        <a :href="card.detail_link" class="filter-card__more-link" v-if="card.detail_link.length">
          {{ moreLabel }}
          <svg width="28" height="12" xmlns="http://www.w3.org/2000/svg">
            <g fill="#C31932" fill-rule="evenodd">
              <path d="M0 7V5h24v2z"/>
              <path d="M28 6 18 0v12z"/>
            </g>
          </svg>
        </a>
      </div>
      <button type="button" class="btn-plus" :aria-expanded="[!crop]" :aria-controls="`filter-card-collapse-` + id" aria-label="Toggle card" ref="cardBtn" @click.prevent="collapseBox"></button>
    </div>
  </div>
</template>

<script>
import store from '../store/Store';

export default {
  name: "AppFilterCards",
  props: {
    id: Number,
    card: Object,
    moreLabel: String,
  },
  data() {
    return {
      crop: false
    }
  },
  methods: {
    showImageModal() {
      // console.log('modal show');
      // console.log(this.card.map);
      store.commit('Popups/setImageModalUrl', this.card.map)
      store.commit('Popups/togglePopups', 'Image')
    },
    collapseBox() {
      this.crop = !this.crop
    }
  }
}
</script>
